import { HttpInterceptorFn, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';
import { ToastService } from '../services/toast.service';
import { PlanLimitModalService } from '../services/plan-limit-modal.service';

// Backend gates return 200 OK with { success:false, code:"LIMIT_REACHED" | "FEATURE_NOT_INCLUDED" }
// (see RequireWithinLimitAttribute / RequireFeatureAttribute). The HTTP status is fine, so the
// catchError branch never fires — we have to inspect the body on the success path too.
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);
  const planLimitModal = inject(PlanLimitModalService);

  return next(req).pipe(
    tap(event => {
      if (!(event instanceof HttpResponse)) return;
      const body: any = event.body;
      if (!body || body.success !== false || !body.code) return;

      if (body.code === 'LIMIT_REACHED') {
        planLimitModal.showLimit({
          limit: body.limit,
          current: body.current,
          max: body.max,
          planCode: body.planCode,
          message: body.message,
        });
      } else if (body.code === 'FEATURE_NOT_INCLUDED') {
        planLimitModal.showFeature({
          feature: body.feature,
          planCode: body.planCode,
          message: body.message,
        });
      }
    }),
    catchError((error: HttpErrorResponse) => {
      switch (error.status) {
        case 403:
          console.error('Access forbidden:', error);
          break;
        case 404:
          console.error('Resource not found:', error);
          break;
        case 500:
        case 502:
        case 503:
          console.error('Server error:', error);
          break;
        default:
          if (error.status !== 401) {
            console.error('HTTP Error:', error);
          }
      }
      return throwError(() => error);
    })
  );
};
